import { ImportDataInvestmentsBasicQuery } from '@/__generated__/graphql';
import Button from '@/components/basicComponents/button';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { ISeriesCodesTableData } from '@/components/settings-page/importData/types';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import styled from 'styled-components';
import { RowStatus } from '../../entityCodes/table/cell/rowStatus';
import { columns } from '../constants';

interface TableBodyProps {
  tableData: ISeriesCodesTableData[];
  investmentList: ImportDataInvestmentsBasicQuery['Investments']['data'];
  investmentListLoading: boolean;
  handleChangeAssignment: (investmentId: string, seriesCode: string) => void;
  resetAssignment: (seriesCode: string) => void;
}

const TableBody = ({ tableData, investmentList, investmentListLoading, handleChangeAssignment, resetAssignment }: TableBodyProps) => {
  if (!tableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableData.map((row) => (
        <CustomTableRowWrapper key={row.id}>
          <TableRowCell width={columns[0].width}>
            <TextCell>{row.investmentCode}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <TextCell>{row.seriesName}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            {row.seriesStatus === 'Assigned' ? (
              <TextCell>{row.seriesAssignment}</TextCell>
            ) : (
              <Select
                value={row.seriesAssignment}
                previewValue={row.seriesAssignment === 'Select A Strategy' ? '' : row.seriesAssignment}
                setValue={(value) => handleChangeAssignment(value, row.investmentCode)}
                options={investmentList.map((investment) => createSimpleSelectOption(investment.id, investment.name))}
                loading={investmentListLoading}
                size="md"
                additionalOption={
                  <ClearSelectionButtonWrapper>
                    <Button
                      size="sm"
                      onClick={() => resetAssignment(row.investmentCode)}
                      styleType={row.seriesAssignment === 'Select A Strategy' ? 'disabled' : 'outline'}
                    >
                      Clear Selection
                    </Button>
                  </ClearSelectionButtonWrapper>
                }
                withSearch
              />
            )}
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>
              <RowStatus status={row.seriesStatus} />
            </TextCell>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;

const ClearSelectionButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
